import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material';
import { atom, useAtomValue, useSetAtom } from 'jotai';
import * as React from 'react';

interface IMessage {
  message: string;
  yes: string;
  no: string;
  resolve: (answer: boolean) => void;
}

const messagesAtom = atom<IMessage[]>([]);

export function useConfirm() {
  const setMessages = useSetAtom(messagesAtom);
  return React.useCallback((message: string, yes: string, no: string) => {
    return new Promise<boolean>(resolve => {
      setMessages(messages =>
        messages.concat({
          message,
          yes,
          no,
          resolve
        })
      );
    });
  }, []);
}

export function ConfirmProvider() {
  const [current] = useAtomValue(messagesAtom);
  const setMessages = useSetAtom(messagesAtom);

  const handleSet = (answer: boolean) => {
    current.resolve(answer);
    setMessages(messages => messages.slice(1));
  };

  return React.useMemo(
    () => (
      <Dialog open={Boolean(current)}>
        <DialogTitle>{current?.message}</DialogTitle>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleSet(true)}
          >
            {current?.yes}
          </Button>
          <Button variant="outlined" onClick={() => handleSet(false)}>
            {current?.no}
          </Button>
        </DialogActions>
      </Dialog>
    ),
    [current]
  );
}
